import React, { useState } from "react";
import { Link, useNavigate  } from "react-router-dom";
import { PlanCards } from "../components/PlanCards";

export const Plans = () => {
  const [isYouWillEarnCollapsed, setIsYouWillEarnCollapsed] = useState(true);
  const [isYourEarningCollapsed, setIsYourEarningCollapsed] = useState(true);
  const [isMacTokenCollapsed, setIsMacTokenCollapsed] = useState(true);
  const navigate = useNavigate();

  const toggleYouWillEarnCollapse = () => {
    setIsYouWillEarnCollapsed(prevState => !prevState);
  };

  const toggleYourEarningCollapse = () => {
    setIsYourEarningCollapsed(prevState => !prevState);
  };

  const toggleMacTokenCollapse = () => {
    setIsMacTokenCollapsed(prevState => !prevState);
  };

  return (
    <div className="mx-2" >
      <div className="d-flex justify-content-start pt-3 mx-2 pb-3">
        <Link
          to="/"
        >
          <img src="./images/store/cards_leftarrow.png" alt="leftarrow" />
        </Link>
        <h2 className="font-33 font-700" style={{ marginLeft: "12px" }}>Plans</h2>
      </div>
      <PlanCards />
      {/* You will Earn */}
      <div
        style={{
          marginTop: "15px"
        }}
      >
        <div 
          onClick={toggleYouWillEarnCollapse}
          style={{
            cursor: "pointer",
            background: "linear-gradient(122.28deg, #C4C4FF -3.03%, #424191 71.69%, #16156B 97.07%)",
            fontSize: "25px",
            fontWeight: 600,
            lineHeight: "38px",
            borderRadius: "17px",
            color: "#FFFFFF",
          }}
        >
          <div
            style={{
              padding: "25px 25px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              You Will Earn
            </div>
            {isYouWillEarnCollapsed && (
              <img src="./images/store/plans_downarrow.png" alt="downarrow" />
            )}
            {!isYouWillEarnCollapsed && (
              <img src="./images/store/plans_uparrow.png" alt="uparrow" />
            )}
          </div>
          {!isYouWillEarnCollapsed && (
            <div
            style={{
              background: "linear-gradient(122.28deg, #C4C4FF -3.03%, #16156B 97.07%)",
              borderRadius: "17px",
              padding: "15px 25px",
            }}
          >
            <h2 className="text-left font-33 font-600">
              Join The Mapex Ecosystem Today & Start Earning 1.5% Daily returns
            </h2>
            <div
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <p className="text-left font-15 font-300" style={{ width: "200px", color: "#C3C4FF", lineHeight: "24px" }}>
                Made to spend & unlimited cash back for You!
              </p>
              <Link
                to="/mapex"
                className="form-custom form-icon"
                style={{
                  background: "#C3C4FF",
                  width: "151px",
                  height: "48px",
                  borderRadius: "25px",
                  padding: "12px 20px",
                  color: "#16156B",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "34px",
                }}
              >
                <p className="font-16 font-500" style={{ color: "#16156B", marginBottom: "0px", marginLeft: "-40px", zIndex: "5" }}>
                  Learn More
                </p>
                <i><img src="./images/store/cards_learnmore.png" alt="learnmore" style={{ marginTop: "-18px", marginLeft:"28px" }}/></i>
              </Link>
            </div>
          </div>
          )}
        </div>
        
      </div>
      {/* Your Earning */}
      <div
        style={{
          marginTop: "15px"
        }}
      >
        <div 
          onClick={toggleYourEarningCollapse}
          style={{
            cursor: "pointer",
            background: "linear-gradient(122.28deg, #C4C4FF -3.03%, #424191 71.69%, #16156B 97.07%)",
            fontSize: "25px",
            fontWeight: 600,
            lineHeight: "38px",
            borderRadius: "17px",
            padding: "25px 25px",
            color: "#FFFFFF",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              Your Earning
            </div>
            {isYourEarningCollapsed && (
              <img src="./images/store/plans_downarrow.png" alt="downarrow" />
            )}
            {!isYourEarningCollapsed && (
              <img src="./images/store/plans_uparrow.png" alt="uparrow" />
            )}
          </div>
          {!isYourEarningCollapsed && (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid white",
                  marginTop: "15px",
                }}
              >
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>Daily</div>
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>1.5%$</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid white",
                  marginTop: "15px",
                }}
              >
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>Monthly</div>
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>1,124.70$</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid white",
                  marginTop: "15px",
                }}
              >
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>Yearly</div>
                <div style={{ paddingBottom: "2px", fontSize: "20px", fontWeight: "500", color: "#C3C4FF" }}>15000$</div>
              </div>
            </div>
          )}
        </div>
        
      </div>
      {/* MAC Token Rewards */}
      <div
        style={{
          marginTop: "15px"
        }}
      >
        <div 
          onClick={toggleMacTokenCollapse}
          style={{
            cursor: "pointer",
            background: "linear-gradient(122.28deg, #C4C4FF -3.03%, #424191 71.69%, #16156B 97.07%)",
            fontSize: "25px",
            fontWeight: 600,
            lineHeight: "38px",
            borderRadius: "17px",
            padding: "25px 25px",
            color: "#FFFFFF",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              MAC Token Rewards
            </div>
            {isMacTokenCollapsed && (
              <img src="./images/store/plans_downarrow.png" alt="downarrow" />
            )}
            {!isMacTokenCollapsed && (
              <img src="./images/store/plans_uparrow.png" alt="uparrow" />
            )}
          </div>
          {!isMacTokenCollapsed && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "25px",
                gap: "6px",
                alignItems: "center",
                textAlign: "center"
              }}
            >
              <div style={{ width: "32%", borderRadius: "12px", opacity: "0.3", height: "130px", display: "flex", flexDirection:"column", justifyContent: "space-between",  padding: "12px 25px", fontSize: "20px", fontWeight: "500", background: "gray",
              }}>
                <div>Daily</div>
                <div>100$</div>
              </div>
              <div style={{ width: "32%", borderRadius: "12px", opacity: "0.3", height: "130px", display: "flex", flexDirection:"column", justifyContent: "space-between",  padding: "12px 17px", fontSize: "20px", fontWeight: "500", background: "gray",
              }}>
                <div>Monthly</div>
                <div>1,000$</div>
              </div>
              <div style={{ width: "30%", borderRadius: "12px", opacity: "0.3", height: "130px", display: "flex", flexDirection:"column", justifyContent: "space-between",  padding: "12px 17px", fontSize: "20px", fontWeight: "500", background: "gray",
              }}>
                <div>Yearly</div>
                <div>15000$</div>
              </div>
            </div>
          )}
        </div>
        
      </div>
    </div>
  );
};
